import React from 'react'

export const LastMinuteIcon = ({size = 20}: {size?: number}) => (
  <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
    <path
      d="M12.9976 21.4153L2.87608 11.4734C2.34675 10.9051 2.03826 10.1662 2.00641 9.39027L2.00039 3.80872C2.00039 2.8595 2.76989 2.09 3.71911 2.09H9.29808C10.0612 2.11874 10.7894 2.4175 11.3528 2.93303C11.3688 2.94738 11.3832 2.96256 11.3984 2.97857L11.3992 2.97944L21.4864 12.8999C21.8134 13.2213 21.9984 13.66 22.0004 14.1185C22.0023 14.577 21.821 15.0172 21.4967 15.3413L15.4253 21.411C14.7611 22.0756 13.6863 22.0836 13.0122 21.429L12.9976 21.4153ZM7.15655 5.95712C6.44464 5.95712 5.86751 6.53425 5.86751 7.24616C5.86751 7.95808 6.44464 8.5352 7.15655 8.5352C7.86847 8.5352 8.44559 7.95808 8.44559 7.24616C8.44559 6.53425 7.86847 5.95712 7.15655 5.95712Z"
      fill="currentColor"
    />
  </svg>
)
